import React from "react";
import { Select as ChakraSelect, type SelectProps as ChakraSelectProps } from "@chakra-ui/react";
import { ChevronDownIcon } from "../icons";

type BaseSelectProps = {
  /**
   * Indicates if the input is invalid. If `true`, the input will be styled with an error state.
   * @default false
   */
  isInvalid?: boolean;

  /**
   * Indicates if the input is disabled. If `true`, the input will be styled with a disabled state.
   * @default false
   */
  isDisabled?: boolean;
};

export type SelectProps = BaseSelectProps & Omit<ChakraSelectProps, "isInvalid" | "isDisabled" | "size">;

export function Select({ isInvalid, isDisabled, ...props }: SelectProps) {
  return <ChakraSelect isInvalid={isInvalid} isDisabled={isDisabled} size="md" icon={<ChevronDownIcon />} {...props} />;
}
